import React from 'react';

import { Typography } from '@material-ui/core';
import { PROJECT_STATUS } from '../../interfaces/project';

import { useStatusBarStyles } from './styles';

const StatusBar: React.FC<{ status: PROJECT_STATUS }> = ({ status }) => {
  const classes = useStatusBarStyles();
  return (
    <div className={classes.statusRow}>
      <div className={classes.statusContainer}>
        <div className={classes.step}>
          <div
            className={`${classes.bulletSmall} hasNext  ${
              status === PROJECT_STATUS.DRAFT ? 'current' : ''
            }`}
          />
        </div>
        <div className={classes.step}>
          <div
            className={`${classes.bulletSmall} hasNext  ${
              status === PROJECT_STATUS.TEST ? 'current' : ''
            }`}
          />
        </div>
        <div className={classes.step}>
          <div
            className={`${classes.bulletSmall} hasNext  ${
              status === PROJECT_STATUS.REVIEW ? 'current' : ''
            }`}
          />
        </div>
        <div className={classes.step}>
          <div
            className={`${classes.bulletSmall} ${status === PROJECT_STATUS.LIVE ? 'current' : ''}`}
          />
        </div>
      </div>

      <Typography variant="body2">{status}</Typography>
    </div>
  );
};

export default StatusBar;
